// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentHybridPatientSearchResultModel {
    static getAttributeTypeMap() {
        return EnrollmentHybridPatientSearchResultModel.attributeTypeMap;
    }
}
EnrollmentHybridPatientSearchResultModel.discriminator = undefined;
EnrollmentHybridPatientSearchResultModel.attributeTypeMap = [
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "MedBenEnrollmentDemographicsModel"
    },
    {
        "name": "guardianInfo",
        "baseName": "guardianInfo",
        "type": "EnrollmentGuardianInfoModel"
    },
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "EnrollmentMedBenInsuranceVerificationModel"
    },
    {
        "name": "enrollments",
        "baseName": "enrollments",
        "type": "Array<HybridEnrollmentHistoryModel>"
    }
];
//# sourceMappingURL=enrollmentHybridPatientSearchResultModel.js.map